import { HR_LEFT_MENUS } from 'config/hrMenuConfig';

function walkMenus(nodes, visit) {
  (nodes || []).forEach((node) => {
    visit(node);
    if (node.children?.length) walkMenus(node.children, visit);
  });
}

/** 메뉴 트리에서 screenId(또는 progId)로 leaf를 찾는다. */
export function findMenuByScreenId(screenId) {
  const key = String(screenId || '').trim();
  if (!key) return null;
  let found = null;
  Object.values(HR_LEFT_MENUS || {}).forEach((trees) => {
    if (found) return;
    walkMenus(trees, (node) => {
      if (found) return;
      if (node.children?.length) return;
      const sid = node.screenId || node.progId || '';
      if (sid === key) found = node;
    });
  });
  return found;
}

export function menuToTabPayload(menuItem) {
  if (!menuItem) return null;
  const componentPath = menuItem.componentPath || '';
  const url = menuItem.url || menuItem.path || '';
  const progId = menuItem.progId || '';
  const menuId = menuItem.id || menuItem.menuNo;
  const menuLabel = menuItem.label || menuItem.menuNm || '메뉴';
  const component = menuItem.component || progId || componentPath || menuItem.id || menuItem.menuNo;
  return {
    id: menuId,
    label: menuLabel,
    path: url || `/${component}`,
    component,
    componentPath,
    screenId: menuItem.screenId || menuItem.progId || '',
  };
}
